export default "__VITE_ASSET__B711wzhU__"